import {
  Typography,
  Link,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";

export interface CardPageProps {
  image?: string | null;
  title?: string;
  content?: string;
  urlFirst?: string;
  textFirst?: string;
  /** Las tarjetas con un solo link no pasan estos tres. */
  urlSecond?: string;
  textSecond?: string;
  onSecondClick?: (() => void) | null;
}

export const CardPage = ({
  image,
  title,
  content,
  urlFirst,
  textFirst,
  urlSecond,
  textSecond,
  onSecondClick,
}: CardPageProps) => {
  return (
    <Card sx={{ minHeight: "405px" }}>
      <CardMedia component="img" alt={title} height="140" image={image ?? undefined} />
      <CardContent sx={{ minHeight: "190px" }}>
        <Typography gutterBottom variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: "justify" }}>
          {content}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          component={Link}
          target="_blank"
          rel="noreferrer"
          href={urlFirst}
          underline="none"
        >
          {textFirst}
        </Button>

        {onSecondClick ? (
          <Button onClick={onSecondClick}>{textSecond}</Button>
        ) : (
          <Button
            component={Link}
            target="_blank"
            rel="noreferrer"
            href={urlSecond}
            underline="none"
          >
            {textSecond}
          </Button>
        )}
      </CardActions>
    </Card>
  );
};
